<template>
    <a class="avp-contact-link" :href="phoneLink">{{ $t('generic.support.phone') }}</a>
</template>

<script>

export default {
        name: 'CustomerServicePhone',
        computed: {
          phoneLink () {
            return 'tel:' + this.$i18n.t( 'generic.support.phone_url' );
          }
        },
    }
</script>
